<template>
  <mt-popup v-model="moduleState.roleList" :modal=false popup-transition="popup-fade" class="page-module roles-factory">
    <app-header v-bind="headerConfig"></app-header>

    <div class="content" :class="{'scroll-shadow': scrollShadow}" ref="roleContent">
      <div class="inner" ref="roleContentInner">
        <ul class="role-wrapper" ref="roleWrapper">
          <li class="role-list aside clearfix">
            <div class="role-pic fl">
              <img src="../../static/image/aside.jpg">
            </div>
            <div class="role-detail">
              <ul class="items">
                <li class="row">
                  <span class="hint">系统</span>
                  <div class="name elli">旁白</div>
                </li>
                <li class="row introduce">
                  系统默认的旁白君，会以不同的形式在不同创作 模式中出场。不可修改，不可删除。
                </li>
              </ul>
            </div>
          </li>
          <li v-if="storyRoles.length > 0 && $index > 0" v-for="(role, $index) in storyRoles" :class="{act: role.isEdit}" :key="role.id" class="role-list" @click="openRoleEditMenu(role)">
            <div class="role-pic fl" :class="getRoleStatusSign(role, $index)">
              <img :src="commentMethods.getRoleCover(role)">
            </div>
            <div class="role-detail">
              <ul class="items">
                <li class="row">
                  <span class="hint" :class="role.sex" v-text="role.sex ==='man'? '男性': '女性'"></span>
                  <div class="name" v-text="commentMethods.roleNameProcess(role.name)"></div>
                </li>
                <li class="row introduce" v-text="role.describe === '' ? '': role.describe"></li>
              </ul>
            </div>
            <ul class="edit-role-menu" :class="{act: role.isEdit}">
              <li class="option del" @click="roleDel(role.id, role)">删除角色</li>
              <li class="option edit" @click="roleEdit(role.id)">编辑角色</li>

              <li class="option stage no-quit" @click="roleQuitStage(role, $index)" v-if="roleQuitFun('on', role, $index)">
                取消登场
              </li>
              <li class="option stage no-quit-forbidden" @click.stop="" v-else-if="roleQuitFun('off', role, $index)">取消登场</li>
              <li class="option stage" @click="roleSelect(role, $index, true)" v-else>登场</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <div class="gender man" @click="creatingRole('man',96)">
      <i class="gender-bg man-bg"></i>
      <p class="gender-note">新建男性角色</p>
    </div>
    <div class="gender woman" @click="creatingRole('woman',97)">
      <i class="gender-bg woman-bg"></i>
      <p class="gender-note">新建女性角色</p>
    </div>

    <div class="start-story" @click="useRole" v-text="'使用选中角色' + getCostarCount()"></div>
    <div class="modal" v-if="modal"></div>
  </mt-popup>
</template>

<script>
  import Vue from 'vue';
  import {mapState} from 'vuex';
  import {Toast} from 'mint-ui';
  import store from '../store/store';
  import AppHeader from '../components/header';
  import {ComponentName, Methods} from '../const/common';

  export default {
    name: 'role_list',
    components: {
      'app-header': AppHeader
    },
    props: {
      sundry: {},
      oldProtagonist: {},
      oldCoster: {
        type: Array
      }
    },
    computed: {
      hasMainRole() {
        return store.state.watchHasMainRole;
      },
      watchRoleWrapperHeight() {
        return this.roleWrapperHeight;
      },
      ...mapState(['moduleState', 'storyRoles', 'stageRoles'])
    },
    data() {
      return {
        headerConfig: {
          title: '角色列表',
          isStoryMenu: false,
          backNote: store.state.nextPageHeaderConf.roleList.backNote,
          backPage: store.state.nextPageHeaderConf.roleList.backPage,
          closeModule: ComponentName.ROLE_LIST
        },
        mainRoleIndex: null,
        isChange: false,
        commentMethods: Methods,
        selectCount: 0,
        modal: false,
        contentHeight: 0,
        roleWrapperHeight: 0,
        scrollShadow: false
      }
    },
    store,
    methods: {
      close() {
        Methods.cutComponent([ComponentName.ROLE_LIST], false);
      },
      getRoleStatusSign(role, index) {
        let _res = '';

        if (role.status === 'main' && role.stage) {
          _res = 'leading-sign';
        } else if (this.stageRoleSign(role, index)) {
          _res = 'costar-sign';
        }
        return _res;
      },
      getCostarCount() {
        let _res = '';

        if (this.stageRoles.status === 'costar' && this.selectCount > 0) {
          _res = `(${this.selectCount})`;
        }
        return _res;
      },
      roleSign(role, index) {
        if ((this.stageRoleSign(role, index))) {
          return true;
        }
        return false;
      },
      roleQuitFun(type, role, index) {
        let _res = false, _roleSign = this.roleSign(role, index),
          _canStoryOutCharacter = Methods.canStoryOutCharacter(role.id);

        if (type === 'on') {
          if (_roleSign && _canStoryOutCharacter) {
            _res = true;
          }
        } else {
          if (_roleSign && !_canStoryOutCharacter) {
            _res = true;
          }
        }
        return _res;
      },
      slideUpRoleMenu(role, isAll) {
        store.state.storyRoles.forEach(function (item) {
          if (isAll || (role && item.id !== role.id)) {
            Vue.set(item, 'isEdit', false);
          }
        });
      },
      openRoleEditMenu(role) {
        let _role = role, allowChangMain = true;

        if (this.stageRoles.status === 'costar' && role.status === 'main') {
          return;
        }
        if (this.stageRoles.status === 'main') {
          this.storyRoles.forEach(function (role) {
            if (_role.id !== role.id && role.status === 'main') {
              allowChangMain = false;
              return;
            }
          });
        }

        if (!allowChangMain) {
          return Toast({
            message: '您已经有主角'
          });
        }

        this.slideUpRoleMenu(role, false);
        Vue.set(role, 'isEdit', !role.isEdit);
        Methods.checkChapterHash(91);
      },
      slideModal(type) {
        this.modal = type;
      },
      roleDel(id, role) {
        let _this = this;

        this.slideModal(true);

        if (Middle.MiddleCommand.canDeleteCharacter(id)) {
          Methods.messageConfirm('', '该角色将被删除，是否确认？', '是', '否', function() {
            if (role.status === 'main') {
              _this.mainRoleIndex = null;
            }
            Methods.removeRole(id);
            _this.slideModal(false);
          }, function() {
            _this.slideModal(false);
          });
        } else {
          Methods.messageAlert('警告！', '该角色在故事中有对话内容，无法删除。', function() {
            this.slideModal(false);
          }.bind(this));
        }
        Methods.checkChapterHash(92);
      },
      roleEdit(id) {
        Methods.changRoleInfo(id);
        Methods.setHeaderConf('createRole', '角色列表', ComponentName.ROLE_LIST);
        Methods.checkChapterHash(93);
      },
      roleQuitStage(role, index) {
        Methods.stroryOutCharacter(role.id);
        Methods.checkChapterHash(94);
        this.roleSelect(role, index, false);
      },
      stageRoleSign(role, index) {
        var _res = false;

        if (this.stageRoles.status === 'main' && role.status === 'main') {
          this.mainRoleIndex = index;
        }
        if (role.stage) {
          _res = true;
        }
        return _res;
      },
      roleSelect(role, i, _isChange) {
        this.isChange = true;
        if (this.stageRoles.status === 'main') {
          this.mainRoleIndex = null;

          if (_isChange) {
            this.mainRoleIndex = i;
            Vue.set(role, 'status', 'main');
            Vue.set(role, 'stage', true);
          } else {
            Vue.set(role, 'status', 'costar');
            Vue.set(role, 'stage', false);
          }
        } else if (this.stageRoles.status === 'costar') {
          if (role.status !== 'main') {
            Vue.set(role, 'status', 'costar');
            Vue.set(role, 'act', !role.act);
            Vue.set(role, 'stage', !role.stage);

            if (role.act) {
              this.selectCount += 1;
            } else {
              this.selectCount -= 1;
            }
          }
        }
        Methods.checkChapterHash(95);
      },
      creatingRole(gender, hash) {
        store.state.createRole.gender = gender;
        Methods.setHeaderConf('createRole', '角色列表', ComponentName.ROLE_LIST);
        Methods.openEditRoleView('edit');
        Methods.checkChapterHash(hash);
      },
      useRole() {
        let _note = '当前未选中任何角色\n' + '请选中一名角色，将其配置为主角';

        if (this.stageRoles.status === 'main') {
          let _index = this.mainRoleIndex;

          if (_index === null) {
            return alert(_note);
          }

          for (let i in this.stageRoles.costar) {
            if (this.stageRoles.costar[i].id === this.storyRoles[_index].id) {
              this.stageRoles.costar.splice(i, 1);
            }
          }

          this.stageRoles.main = [this.storyRoles[_index]];
          Vue.set(this.storyRoles[_index], 'status', 'main');
        } else if (this.stageRoles.status === 'costar') {
          this.stageRoles.costar = [];

          this.storyRoles.forEach(function (role) {
            if (role.stage && role.status !== 'main' && role.characterType !== Methods.getRoleStatus('sys')) {
              store.state.stageRoles.costar.push(role);
            }
          })
        }
        Methods.cutComponent([ComponentName.CHAPTER_SET], true);
        this.close();
        Methods.checkChapterHash(98);
      },
    },
    mounted: function () {
      var _this = this, count = 0;

      for (let i = 0; i < this.storyRoles.length; i++) {
        if (this.storyRoles[i].act && !this.storyRoles[i].isMain) {
          count += 1;
        }
      }
      _this.selectCount = count;

      this.$nextTick(function () {
        this.contentHeight = this.$refs.roleContent.clientHeight;
        this.roleWrapperHeight = this.$refs.roleWrapper.clientHeight

        this.$refs.roleContentInner.onscroll = function () {
          if (_this.contentHeight + _this.$refs.roleContentInner.scrollTop >= _this.roleWrapperHeight) {
            _this.scrollShadow = false;
          } else {
            _this.scrollShadow = true;
          }
        }
      });
    },
    watch: {
      hasMainRole(newVal) {
        if (newVal) {
          this.useRole();
          this.slideUpRoleMenu(false, true);
          store.state.watchHasMainRole = false;
        }
      },
      watchRoleWrapperHeight() {
        if (this.contentHeight < this.roleWrapperHeight) {
          this.scrollShadow = true;
        }
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/role_list.css";
</style>



// WEBPACK FOOTER //
// src/components/role_list.vue